var _path, _path2, _path3, _path4, _path5, _g, _path6, _g2, _path7, _g3, _path8, _g4, _path9, _g5, _path10, _g6, _path11, _g7, _path12, _g8, _path13, _g9, _path14, _g10, _path15, _g11, _path16, _g12, _path17, _g13, _path18, _g14, _path19, _g15, _path20, _g16, _path21, _g17, _path22, _g18, _path23, _g19, _path24, _g20, _path25, _g21, _path26, _g22, _path27, _g23, _path28, _g24, _path29, _g25, _path30, _g26, _path31, _g27, _path32, _g28, _path33, _g29, _path34, _g30, _path35, _g31, _path36, _g32, _path37, _g33, _path38, _g34, _path39, _g35, _path40, _g36, _path41, _g37, _path42, _g38, _path43, _g39, _path44, _g40, _path45, _g41, _path46, _g42, _path47, _g43, _path48, _g44, _path49, _g45, _path50, _g46, _path51, _g47, _path52, _g48, _path53, _g49, _path54, _g50, _path55, _g51, _path56, _g52, _path57, _g53, _path58, _g54, _path59, _g55, _path60, _g56, _path61, _g57, _path62, _g58, _path63, _g59, _path64, _g60, _path65, _g61, _path66, _g62, _path67, _g63, _path68, _g64, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardTopPattern(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 643,
    height: 781,
    viewBox: "0 0 643 781",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M641.741 125.683L640.69 124.862L323.791 530.916L6.8916 124.862L5.84082 125.683L323.791 533.083L641.741 125.683Z",
    fill: "url(#paint0_linear_2925_19743)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M641.741 125.683L640.69 124.862L323.791 530.916L6.8916 124.862L5.84082 125.683L323.791 533.083L641.741 125.683Z",
    fill: "url(#paint1_linear_2925_19743)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M642.581 0H5L323.791 408.478L642.581 0ZM7.73145 1.33301H639.851L323.791 406.311L7.73145 1.33301Z",
    fill: "url(#paint2_linear_2925_19743)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M420.434 655.853L420.116 655.444L323.791 531.196L227.156 655.853L227.473 656.262L323.791 780.499L420.434 655.853ZM228.844 655.854L323.791 533.373L418.745 655.854L323.791 778.324L228.844 655.854Z",
    fill: "url(#paint3_linear_2925_19743)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2925_19743",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 319,
    y: 0,
    width: 9,
    height: 779
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M326.649 0.657472C324.123 0.650539 322.855 0.637448 322.855 0.637448C322.855 0.637448 321.588 0.624174 319.061 0.607415C319.165 92.7392 319.221 138.805 319.221 138.805L319.368 267.02L319.524 403.73L319.673 535.165L319.829 670.026C319.829 670.026 319.872 706.148 319.95 778.403C322.485 778.42 323.744 778.433 323.744 778.433C323.744 778.433 325.012 778.447 327.538 778.463C327.46 706.199 327.417 670.066 327.417 670.066L327.261 535.216L327.112 403.78L326.956 267.07L326.809 138.855C326.809 138.855 326.753 92.7892 326.649 0.657472Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2925_19743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326.613 0.685572C324.087 0.71776 322.818 0.638344 322.818 0.638344C322.846 23.6713 322.877 43.828 322.892 61.1025C322.892 61.1025 324.152 61.0842 326.679 61.1499C326.656 43.8754 326.641 23.7185 326.613 0.685572Z",
    fill: "#BABBBA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2925_19743",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 319,
    y: 0,
    width: 9,
    height: 779
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M326.649 0.657472C324.123 0.650539 322.855 0.637448 322.855 0.637448C322.855 0.637448 321.588 0.624174 319.061 0.607415C319.165 92.7392 319.221 138.805 319.221 138.805L319.368 267.02L319.524 403.73L319.673 535.165L319.829 670.026C319.829 670.026 319.872 706.148 319.95 778.403C322.485 778.42 323.744 778.433 323.744 778.433C323.744 778.433 325.012 778.447 327.538 778.463C327.46 706.199 327.417 670.066 327.417 670.066L327.261 535.216L327.112 403.78L326.956 267.07L326.809 138.855C326.809 138.855 326.753 92.7892 326.649 0.657472Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2925_19743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326.675 61.1474C324.149 61.1796 322.888 61.1001 322.888 61.1001C322.904 78.3746 322.925 92.7688 322.942 104.285C322.942 104.285 324.209 104.266 326.737 104.332C326.726 92.8159 326.698 78.4219 326.675 61.1474Z",
    fill: "#989998"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2925_19743",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 319,
    y: 0,
    width: 9,
    height: 779
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M326.649 0.657472C324.123 0.650539 322.855 0.637448 322.855 0.637448C322.855 0.637448 321.588 0.624174 319.061 0.607415C319.165 92.7392 319.221 138.805 319.221 138.805L319.368 267.02L319.524 403.73L319.673 535.165L319.829 670.026C319.829 670.026 319.872 706.148 319.95 778.403C322.485 778.42 323.744 778.433 323.744 778.433C323.744 778.433 325.012 778.447 327.538 778.463C327.46 706.199 327.417 670.066 327.417 670.066L327.261 535.216L327.112 403.78L326.956 267.07L326.809 138.855C326.809 138.855 326.753 92.7892 326.649 0.657472Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2925_19743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326.729 104.334C324.201 104.269 322.935 104.287 322.935 104.287C322.945 115.804 322.956 124.444 322.961 130.202C322.961 130.202 324.228 130.183 326.755 130.249C326.758 124.49 326.739 115.851 326.729 104.334Z",
    fill: "#7F8081"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_2925_19743",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 319,
    y: 0,
    width: 9,
    height: 779
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M326.649 0.657472C324.123 0.650539 322.855 0.637448 322.855 0.637448C322.855 0.637448 321.588 0.624174 319.061 0.607415C319.165 92.7392 319.221 138.805 319.221 138.805L319.368 267.02L319.524 403.73L319.673 535.165L319.829 670.026C319.829 670.026 319.872 706.148 319.95 778.403C322.485 778.42 323.744 778.433 323.744 778.433C323.744 778.433 325.012 778.447 327.538 778.463C327.46 706.199 327.417 670.066 327.417 670.066L327.261 535.216L327.112 403.78L326.956 267.07L326.809 138.855C326.809 138.855 326.753 92.7892 326.649 0.657472Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_2925_19743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326.757 130.247C324.231 130.279 322.963 130.199 322.963 130.199C322.961 135.958 322.977 138.834 322.977 138.834C322.977 138.834 324.244 138.816 326.771 138.882C326.771 138.882 326.732 136.005 326.757 130.247Z",
    fill: "#707374"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_2925_19743",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 319,
    y: 0,
    width: 9,
    height: 779
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M326.649 0.657472C324.123 0.650539 322.855 0.637448 322.855 0.637448C322.855 0.637448 321.588 0.624174 319.061 0.607415C319.165 92.7392 319.221 138.805 319.221 138.805L319.368 267.02L319.524 403.73L319.673 535.165L319.829 670.026C319.829 670.026 319.872 706.148 319.95 778.403C322.485 778.42 323.744 778.433 323.744 778.433C323.744 778.433 325.012 778.447 327.538 778.463C327.46 706.199 327.417 670.066 327.417 670.066L327.261 535.216L327.112 403.78L326.956 267.07L326.809 138.855C326.809 138.855 326.753 92.7892 326.649 0.657472Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_2925_19743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M322.817 0.662135C322.817 0.662135 321.554 0.680523 319.026 0.614859C319.054 23.6478 319.074 43.8047 319.096 61.0791C321.626 61.0469 322.898 61.1262 322.898 61.1262C322.875 43.8518 322.845 23.6951 322.817 0.662135Z",
    fill: "#BABBBA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_2925_19743",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 319,
    y: 0,
    width: 9,
    height: 779
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M326.649 0.657472C324.123 0.650539 322.855 0.637448 322.855 0.637448C322.855 0.637448 321.588 0.624174 319.061 0.607415C319.165 92.7392 319.221 138.805 319.221 138.805L319.368 267.02L319.524 403.73L319.673 535.165L319.829 670.026C319.829 670.026 319.872 706.148 319.95 778.403C322.485 778.42 323.744 778.433 323.744 778.433C323.744 778.433 325.012 778.447 327.538 778.463C327.46 706.199 327.417 670.066 327.417 670.066L327.261 535.216L327.112 403.78L326.956 267.07L326.809 138.855C326.809 138.855 326.753 92.7892 326.649 0.657472Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_2925_19743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M322.889 61.1241C322.889 61.1241 321.626 61.1424 319.095 61.0768C319.117 78.3473 319.131 92.7455 319.141 104.262C321.671 104.229 322.935 104.309 322.935 104.309C322.925 92.7927 322.904 78.3986 322.889 61.1241Z",
    fill: "#989998"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_2925_19743",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 319,
    y: 0,
    width: 9,
    height: 779
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M326.649 0.657472C324.123 0.650539 322.855 0.637448 322.855 0.637448C322.855 0.637448 321.588 0.624174 319.061 0.607415C319.165 92.7392 319.221 138.805 319.221 138.805L319.368 267.02L319.524 403.73L319.673 535.165L319.829 670.026C319.829 670.026 319.872 706.148 319.95 778.403C322.485 778.42 323.744 778.433 323.744 778.433C323.744 778.433 325.012 778.447 327.538 778.463C327.46 706.199 327.417 670.066 327.417 670.066L327.261 535.216L327.112 403.78L326.956 267.07L326.809 138.855C326.809 138.855 326.753 92.7892 326.649 0.657472Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_2925_19743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M322.935 104.311C322.935 104.311 321.676 104.329 319.145 104.264C319.155 115.78 319.166 124.416 319.171 130.174C321.698 130.239 322.962 130.221 322.962 130.221C322.964 124.463 322.945 115.828 322.935 104.311Z",
    fill: "#7F8081"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_2925_19743",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 319,
    y: 0,
    width: 9,
    height: 779
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M326.649 0.657472C324.123 0.650539 322.855 0.637448 322.855 0.637448C322.855 0.637448 321.588 0.624174 319.061 0.607415C319.165 92.7392 319.221 138.805 319.221 138.805L319.368 267.02L319.524 403.73L319.673 535.165L319.829 670.026C319.829 670.026 319.872 706.148 319.95 778.403C322.485 778.42 323.744 778.433 323.744 778.433C323.744 778.433 325.012 778.447 327.538 778.463C327.46 706.199 327.417 670.066 327.417 670.066L327.261 535.216L327.112 403.78L326.956 267.07L326.809 138.855C326.809 138.855 326.753 92.7892 326.649 0.657472Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_2925_19743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M322.964 130.223C322.964 130.223 321.704 130.242 319.177 130.176C319.174 135.935 319.187 138.816 319.187 138.816C321.713 138.784 322.985 138.863 322.985 138.863C322.985 138.863 322.946 135.987 322.971 130.228L322.964 130.223Z",
    fill: "#707374"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_2925_19743",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 319,
    y: 0,
    width: 9,
    height: 779
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M326.649 0.657472C324.123 0.650539 322.855 0.637448 322.855 0.637448C322.855 0.637448 321.588 0.624174 319.061 0.607415C319.165 92.7392 319.221 138.805 319.221 138.805L319.368 267.02L319.524 403.73L319.673 535.165L319.829 670.026C319.829 670.026 319.872 706.148 319.95 778.403C322.485 778.42 323.744 778.433 323.744 778.433C323.744 778.433 325.012 778.447 327.538 778.463C327.46 706.199 327.417 670.066 327.417 670.066L327.261 535.216L327.112 403.78L326.956 267.07L326.809 138.855C326.809 138.855 326.753 92.7892 326.649 0.657472Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_2925_19743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326.773 138.884C324.247 138.916 322.979 138.837 322.979 138.837C322.979 138.837 323.006 140.839 322.975 144.347C322.975 144.347 324.242 144.328 326.769 144.394C326.801 140.891 326.773 138.884 326.773 138.884Z",
    fill: "#6B6D6F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_2925_19743",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 319,
    y: 0,
    width: 9,
    height: 779
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M326.649 0.657472C324.123 0.650539 322.855 0.637448 322.855 0.637448C322.855 0.637448 321.588 0.624174 319.061 0.607415C319.165 92.7392 319.221 138.805 319.221 138.805L319.368 267.02L319.524 403.73L319.673 535.165L319.829 670.026C319.829 670.026 319.872 706.148 319.95 778.403C322.485 778.42 323.744 778.433 323.744 778.433C323.744 778.433 325.012 778.447 327.538 778.463C327.46 706.199 327.417 670.066 327.417 670.066L327.261 535.216L327.112 403.78L326.956 267.07L326.809 138.855C326.809 138.855 326.753 92.7892 326.649 0.657472Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_2925_19743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326.777 144.389C324.25 144.421 322.982 144.342 322.982 144.342C323.027 147.849 322.996 152.857 323.004 158.864C323.004 158.864 324.264 158.846 326.791 158.911C326.791 152.9 326.791 147.897 326.777 144.389Z",
    fill: "#707374"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_2925_19743",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 319,
    y: 0,
    width: 9,
    height: 779
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M326.649 0.657472C324.123 0.650539 322.855 0.637448 322.855 0.637448C322.855 0.637448 321.588 0.624174 319.061 0.607415C319.165 92.7392 319.221 138.805 319.221 138.805L319.368 267.02L319.524 403.73L319.673 535.165L319.829 670.026C319.829 670.026 319.872 706.148 319.95 778.403C322.485 778.42 323.744 778.433 323.744 778.433C323.744 778.433 325.012 778.447 327.538 778.463C327.46 706.199 327.417 670.066 327.417 670.066L327.261 535.216L327.112 403.78L326.956 267.07L326.809 138.855C326.809 138.855 326.753 92.7892 326.649 0.657472Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_2925_19743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326.791 158.919C324.264 158.853 323.004 158.871 323.004 158.871C323.013 170.894 323.033 186.917 323.055 202.945C323.055 202.945 324.322 202.926 326.849 202.992C326.834 186.969 326.815 170.936 326.791 158.919Z",
    fill: "#7F8082"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_2925_19743",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 319,
    y: 0,
    width: 9,
    height: 779
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M326.649 0.657472C324.123 0.650539 322.855 0.637448 322.855 0.637448C322.855 0.637448 321.588 0.624174 319.061 0.607415C319.165 92.7392 319.221 138.805 319.221 138.805L319.368 267.02L319.524 403.73L319.673 535.165L319.829 670.026C319.829 670.026 319.872 706.148 319.95 778.403C322.485 778.42 323.744 778.433 323.744 778.433C323.744 778.433 325.012 778.447 327.538 778.463C327.46 706.199 327.417 670.066 327.417 670.066L327.261 535.216L327.112 403.78L326.956 267.07L326.809 138.855C326.809 138.855 326.753 92.7892 326.649 0.657472Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_2925_19743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326.842 202.987C324.315 203.02 323.055 202.94 323.055 202.94C323.077 218.967 323.088 234.986 323.105 247.009C323.105 247.009 324.372 246.995 326.907 247.061C326.89 235.042 326.864 219.015 326.842 202.987Z",
    fill: "#ADADAC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_2925_19743",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 319,
    y: 0,
    width: 9,
    height: 779
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M326.649 0.657472C324.123 0.650539 322.855 0.637448 322.855 0.637448C322.855 0.637448 321.588 0.624174 319.061 0.607415C319.165 92.7392 319.221 138.805 319.221 138.805L319.368 267.02L319.524 403.73L319.673 535.165L319.829 670.026C319.829 670.026 319.872 706.148 319.95 778.403C322.485 778.42 323.744 778.433 323.744 778.433C323.744 778.433 325.012 778.447 327.538 778.463C327.46 706.199 327.417 670.066 327.417 670.066L327.261 535.216L327.112 403.78L326.956 267.07L326.809 138.855C326.809 138.855 326.753 92.7892 326.649 0.657472Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_2925_19743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326.897 247.061C324.364 247.093 323.099 247.009 323.099 247.009C323.1 253.016 323.111 258.028 323.118 261.536C323.118 261.536 324.381 261.517 326.912 261.583C326.867 258.081 326.906 253.072 326.897 247.061Z",
    fill: "#DCDBD8"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_2925_19743",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 319,
    y: 0,
    width: 9,
    height: 779
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M326.649 0.657472C324.123 0.650539 322.855 0.637448 322.855 0.637448C322.855 0.637448 321.588 0.624174 319.061 0.607415C319.165 92.7392 319.221 138.805 319.221 138.805L319.368 267.02L319.524 403.73L319.673 535.165L319.829 670.026C319.829 670.026 319.872 706.148 319.95 778.403C322.485 778.42 323.744 778.433 323.744 778.433C323.744 778.433 325.012 778.447 327.538 778.463C327.46 706.199 327.417 670.066 327.417 670.066L327.261 535.216L327.112 403.78L326.956 267.07L326.809 138.855C326.809 138.855 326.753 92.7892 326.649 0.657472Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_2925_19743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326.914 261.583C324.384 261.615 323.123 261.531 323.123 261.531C323.092 265.039 323.116 267.041 323.116 267.041C323.116 267.041 324.383 267.027 326.91 267.093C326.91 267.093 326.883 265.091 326.914 261.583Z",
    fill: "#ECEBE9"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_2925_19743",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 319,
    y: 0,
    width: 9,
    height: 779
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M326.649 0.657472C324.123 0.650539 322.855 0.637448 322.855 0.637448C322.855 0.637448 321.588 0.624174 319.061 0.607415C319.165 92.7392 319.221 138.805 319.221 138.805L319.368 267.02L319.524 403.73L319.673 535.165L319.829 670.026C319.829 670.026 319.872 706.148 319.95 778.403C322.485 778.42 323.744 778.433 323.744 778.433C323.744 778.433 325.012 778.447 327.538 778.463C327.46 706.199 327.417 670.066 327.417 670.066L327.261 535.216L327.112 403.78L326.956 267.07L326.809 138.855C326.809 138.855 326.753 92.7892 326.649 0.657472Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_2925_19743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M322.977 138.861C322.977 138.861 321.714 138.879 319.187 138.813C319.187 138.813 319.21 140.815 319.179 144.323C321.705 144.291 322.97 144.371 322.97 144.371C323.001 140.863 322.977 138.861 322.977 138.861Z",
    fill: "#6B6D6F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_2925_19743",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 319,
    y: 0,
    width: 9,
    height: 779
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M326.649 0.657472C324.123 0.650539 322.855 0.637448 322.855 0.637448C322.855 0.637448 321.588 0.624174 319.061 0.607415C319.165 92.7392 319.221 138.805 319.221 138.805L319.368 267.02L319.524 403.73L319.673 535.165L319.829 670.026C319.829 670.026 319.872 706.148 319.95 778.403C322.485 778.42 323.744 778.433 323.744 778.433C323.744 778.433 325.012 778.447 327.538 778.463C327.46 706.199 327.417 670.066 327.417 670.066L327.261 535.216L327.112 403.78L326.956 267.07L326.809 138.855C326.809 138.855 326.753 92.7892 326.649 0.657472Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_2925_19743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M322.979 144.366C322.979 144.366 321.719 144.384 319.192 144.318C319.16 147.821 319.202 152.829 319.203 158.841C321.733 158.808 322.997 158.888 322.997 158.888C322.996 152.881 322.985 147.873 322.979 144.366Z",
    fill: "#707374"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_2925_19743",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 319,
    y: 0,
    width: 9,
    height: 779
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M326.649 0.657472C324.123 0.650539 322.855 0.637448 322.855 0.637448C322.855 0.637448 321.588 0.624174 319.061 0.607415C319.165 92.7392 319.221 138.805 319.221 138.805L319.368 267.02L319.524 403.73L319.673 535.165L319.829 670.026C319.829 670.026 319.872 706.148 319.95 778.403C322.485 778.42 323.744 778.433 323.744 778.433C323.744 778.433 325.012 778.447 327.538 778.463C327.46 706.199 327.417 670.066 327.417 670.066L327.261 535.216L327.112 403.78L326.956 267.07L326.809 138.855C326.809 138.855 326.753 92.7892 326.649 0.657472Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_2925_19743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M323.003 158.888C323.003 158.888 321.74 158.906 319.208 158.841C319.225 170.859 319.237 186.883 319.259 202.909C321.789 202.877 323.053 202.961 323.053 202.961C323.031 186.934 323.019 170.911 323.003 158.888Z",
    fill: "#7F8082"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_2925_19743",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 319,
    y: 0,
    width: 9,
    height: 779
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M326.649 0.657472C324.123 0.650539 322.855 0.637448 322.855 0.637448C322.855 0.637448 321.588 0.624174 319.061 0.607415C319.165 92.7392 319.221 138.805 319.221 138.805L319.368 267.02L319.524 403.73L319.673 535.165L319.829 670.026C319.829 670.026 319.872 706.148 319.95 778.403C322.485 778.42 323.744 778.433 323.744 778.433C323.744 778.433 325.012 778.447 327.538 778.463C327.46 706.199 327.417 670.066 327.417 670.066L327.261 535.216L327.112 403.78L326.956 267.07L326.809 138.855C326.809 138.855 326.753 92.7892 326.649 0.657472Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_2925_19743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M323.053 202.964C323.053 202.964 321.79 202.982 319.259 202.917C319.281 218.939 319.292 234.967 319.309 246.985C321.839 247.051 323.103 247.033 323.103 247.033C323.094 235.01 323.075 218.99 323.053 202.964Z",
    fill: "#ADADAC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_2925_19743",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 319,
    y: 0,
    width: 9,
    height: 779
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M326.649 0.657472C324.123 0.650539 322.855 0.637448 322.855 0.637448C322.855 0.637448 321.588 0.624174 319.061 0.607415C319.165 92.7392 319.221 138.805 319.221 138.805L319.368 267.02L319.524 403.73L319.673 535.165L319.829 670.026C319.829 670.026 319.872 706.148 319.95 778.403C322.485 778.42 323.744 778.433 323.744 778.433C323.744 778.433 325.012 778.447 327.538 778.463C327.46 706.199 327.417 670.066 327.417 670.066L327.261 535.216L327.112 403.78L326.956 267.07L326.809 138.855C326.809 138.855 326.753 92.7892 326.649 0.657472Z",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_2925_19743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M323.099 247.037C323.099 247.037 321.839 247.051 319.309 246.985C319.31 252.997 319.32 258.005 319.327 261.513C321.853 261.48 323.122 261.565 323.122 261.565C323.153 258.057 323.108 253.045 323.099 247.037Z",
    fill: "#DCDBD8"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_2925_19743",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 319,
    y: 0,
    width: 9,
    height: 779
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M326.649 0.657472C324.123 0.650539 322.855 0.637448 322.855 0.637448C322.855 0.637448 321.588 0.624174 319.061 0.607415C319.165 92.7392 319.221 138.805 319.221 138.805L319.368 267.02L319.524 403.73L319.673 535.165L319.829 670.026C319.829 670.026 319.872 706.148 319.95 778.403C322.485 778.42 323.744 778.433 323.744 778.433C323.744 778.433 325.012 778.447 327.538 778.463C327.46 706.199 327.417 670.066 327.417 670.066L327.261 535.216L327.112 403.78L326.956 267.07L326.809 138.855C326.809 138.855 326.753 92.7892 326.649 0.657472Z",
    fill: "white"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_2925_19743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M323.122 261.56C323.122 261.56 321.855 261.573 319.327 261.508C319.296 265.011 319.32 267.013 319.32 267.013C321.847 267.078 323.11 267.065 323.11 267.065C323.11 267.065 323.091 265.068 323.122 261.56Z",
    fill: "#ECEBE9"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask20_2925_19743",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 319,
    y: 0,
    width: 9,
    height: 779
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M326.649 0.657472C324.123 0.650539 322.855 0.637448 322.855 0.637448C322.855 0.637448 321.588 0.624174 319.061 0.607415C319.165 92.7392 319.221 138.805 319.221 138.805L319.368 267.02L319.524 403.73L319.673 535.165L319.829 670.026C319.829 670.026 319.872 706.148 319.95 778.403C322.485 778.42 323.744 778.433 323.744 778.433C323.744 778.433 325.012 778.447 327.538 778.463C327.46 706.199 327.417 670.066 327.417 670.066L327.261 535.216L327.112 403.78L326.956 267.07L326.809 138.855C326.809 138.855 326.753 92.7892 326.649 0.657472Z",
    fill: "white"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_2925_19743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326.917 267.095C324.391 267.127 323.127 267.043 323.127 267.043C323.127 267.043 323.152 269.178 323.124 272.916C323.124 272.916 324.387 272.903 326.918 272.968C326.946 269.231 326.917 267.095 326.917 267.095Z",
    fill: "#F2F1EF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask21_2925_19743",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 319,
    y: 0,
    width: 9,
    height: 779
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M326.649 0.657472C324.123 0.650539 322.855 0.637448 322.855 0.637448C322.855 0.637448 321.588 0.624174 319.061 0.607415C319.165 92.7392 319.221 138.805 319.221 138.805L319.368 267.02L319.524 403.73L319.673 535.165L319.829 670.026C319.829 670.026 319.872 706.148 319.95 778.403C322.485 778.42 323.744 778.433 323.744 778.433C323.744 778.433 325.012 778.447 327.538 778.463C327.46 706.199 327.417 670.066 327.417 670.066L327.261 535.216L327.112 403.78L326.956 267.07L326.809 138.855C326.809 138.855 326.753 92.7892 326.649 0.657472Z",
    fill: "white"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_2925_19743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326.926 272.966C324.396 272.998 323.135 272.914 323.135 272.914C323.107 276.651 323.141 281.993 323.154 288.401C323.154 288.401 324.421 288.388 326.952 288.453C326.947 282.045 326.928 276.707 326.926 272.966Z",
    fill: "#ECEBE9"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask22_2925_19743",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 319,
    y: 0,
    width: 9,
    height: 779
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M326.649 0.657472C324.123 0.650539 322.855 0.637448 322.855 0.637448C322.855 0.637448 321.588 0.624174 319.061 0.607415C319.165 92.7392 319.221 138.805 319.221 138.805L319.368 267.02L319.524 403.73L319.673 535.165L319.829 670.026C319.829 670.026 319.872 706.148 319.95 778.403C322.485 778.42 323.744 778.433 323.744 778.433C323.744 778.433 325.012 778.447 327.538 778.463C327.46 706.199 327.417 670.066 327.417 670.066L327.261 535.216L327.112 403.78L326.956 267.07L326.809 138.855C326.809 138.855 326.753 92.7892 326.649 0.657472Z",
    fill: "white"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_2925_19743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326.943 288.456C324.413 288.488 323.152 288.404 323.152 288.404C323.164 301.219 323.182 318.308 323.203 335.402C323.203 335.402 324.466 335.388 326.993 335.454C326.973 318.365 326.962 301.272 326.943 288.456Z",
    fill: "#DCDBD8"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask23_2925_19743",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 319,
    y: 0,
    width: 9,
    height: 779
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M326.649 0.657472C324.123 0.650539 322.855 0.637448 322.855 0.637448C322.855 0.637448 321.588 0.624174 319.061 0.607415C319.165 92.7392 319.221 138.805 319.221 138.805L319.368 267.02L319.524 403.73L319.673 535.165L319.829 670.026C319.829 670.026 319.872 706.148 319.95 778.403C322.485 778.42 323.744 778.433 323.744 778.433C323.744 778.433 325.012 778.447 327.538 778.463C327.46 706.199 327.417 670.066 327.417 670.066L327.261 535.216L327.112 403.78L326.956 267.07L326.809 138.855C326.809 138.855 326.753 92.7892 326.649 0.657472Z",
    fill: "white"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_2925_19743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326.993 335.449C324.467 335.481 323.206 335.397 323.206 335.397C323.227 352.484 323.245 369.573 323.257 382.39C323.257 382.39 324.527 382.376 327.059 382.442C327.04 369.625 327.014 352.537 326.993 335.449Z",
    fill: "#ADADAC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask24_2925_19743",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 319,
    y: 0,
    width: 9,
    height: 779
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M326.649 0.657472C324.123 0.650539 322.855 0.637448 322.855 0.637448C322.855 0.637448 321.588 0.624174 319.061 0.607415C319.165 92.7392 319.221 138.805 319.221 138.805L319.368 267.02L319.524 403.73L319.673 535.165L319.829 670.026C319.829 670.026 319.872 706.148 319.95 778.403C322.485 778.42 323.744 778.433 323.744 778.433C323.744 778.433 325.012 778.447 327.538 778.463C327.46 706.199 327.417 670.066 327.417 670.066L327.261 535.216L327.112 403.78L326.956 267.07L326.809 138.855C326.809 138.855 326.753 92.7892 326.649 0.657472Z",
    fill: "white"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask24_2925_19743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327.051 382.442C324.521 382.475 323.257 382.39 323.257 382.39C323.263 388.798 323.267 394.14 323.276 397.878C323.276 397.878 324.543 397.864 327.071 397.93C327.099 394.193 327.065 388.855 327.051 382.442Z",
    fill: "#7F8082"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask25_2925_19743",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 319,
    y: 0,
    width: 9,
    height: 779
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M326.649 0.657472C324.123 0.650539 322.855 0.637448 322.855 0.637448C322.855 0.637448 321.588 0.624174 319.061 0.607415C319.165 92.7392 319.221 138.805 319.221 138.805L319.368 267.02L319.524 403.73L319.673 535.165L319.829 670.026C319.829 670.026 319.872 706.148 319.95 778.403C322.485 778.42 323.744 778.433 323.744 778.433C323.744 778.433 325.012 778.447 327.538 778.463C327.46 706.199 327.417 670.066 327.417 670.066L327.261 535.216L327.112 403.78L326.956 267.07L326.809 138.855C326.809 138.855 326.753 92.7892 326.649 0.657472Z",
    fill: "white"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask25_2925_19743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327.063 397.933C324.537 397.965 323.277 397.881 323.277 397.881C323.248 401.618 323.274 403.754 323.274 403.754C323.274 403.754 324.537 403.74 327.064 403.806C327.064 403.806 327.035 401.675 327.063 397.933Z",
    fill: "#707374"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask26_2925_19743",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 319,
    y: 0,
    width: 9,
    height: 779
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M326.649 0.657472C324.123 0.650539 322.855 0.637448 322.855 0.637448C322.855 0.637448 321.588 0.624174 319.061 0.607415C319.165 92.7392 319.221 138.805 319.221 138.805L319.368 267.02L319.524 403.73L319.673 535.165L319.829 670.026C319.829 670.026 319.872 706.148 319.95 778.403C322.485 778.42 323.744 778.433 323.744 778.433C323.744 778.433 325.012 778.447 327.538 778.463C327.46 706.199 327.417 670.066 327.417 670.066L327.261 535.216L327.112 403.78L326.956 267.07L326.809 138.855C326.809 138.855 326.753 92.7892 326.649 0.657472Z",
    fill: "white"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask26_2925_19743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M323.127 267.072C323.127 267.072 321.864 267.085 319.336 267.02C319.336 267.02 319.361 269.156 319.333 272.898C321.863 272.865 323.128 272.95 323.128 272.95C323.156 269.212 323.127 267.072 323.127 267.072Z",
    fill: "#F2F1EF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask27_2925_19743",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 319,
    y: 0,
    width: 9,
    height: 779
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M326.649 0.657472C324.123 0.650539 322.855 0.637448 322.855 0.637448C322.855 0.637448 321.588 0.624174 319.061 0.607415C319.165 92.7392 319.221 138.805 319.221 138.805L319.368 267.02L319.524 403.73L319.673 535.165L319.829 670.026C319.829 670.026 319.872 706.148 319.95 778.403C322.485 778.42 323.744 778.433 323.744 778.433C323.744 778.433 325.012 778.447 327.538 778.463C327.46 706.199 327.417 670.066 327.417 670.066L327.261 535.216L327.112 403.78L326.956 267.07L326.809 138.855C326.809 138.855 326.753 92.7892 326.649 0.657472Z",
    fill: "white"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask27_2925_19743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M323.133 272.942C323.133 272.942 321.87 272.956 319.339 272.89C319.311 276.628 319.345 281.97 319.358 288.378C321.885 288.345 323.153 288.43 323.153 288.43C323.147 282.021 323.135 276.679 323.133 272.942Z",
    fill: "#ECEBE9"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask28_2925_19743",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 319,
    y: 0,
    width: 9,
    height: 779
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M326.649 0.657472C324.123 0.650539 322.855 0.637448 322.855 0.637448C322.855 0.637448 321.588 0.624174 319.061 0.607415C319.165 92.7392 319.221 138.805 319.221 138.805L319.368 267.02L319.524 403.73L319.673 535.165L319.829 670.026C319.829 670.026 319.872 706.148 319.95 778.403C322.485 778.42 323.744 778.433 323.744 778.433C323.744 778.433 325.012 778.447 327.538 778.463C327.46 706.199 327.417 670.066 327.417 670.066L327.261 535.216L327.112 403.78L326.956 267.07L326.809 138.855C326.809 138.855 326.753 92.7892 326.649 0.657472Z",
    fill: "white"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask28_2925_19743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M323.151 288.432C323.151 288.432 321.884 288.446 319.356 288.38C319.368 301.197 319.386 318.286 319.407 335.374C321.933 335.342 323.201 335.426 323.201 335.426C323.181 318.332 323.162 301.248 323.151 288.432Z",
    fill: "#DCDBD8"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask29_2925_19743",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 319,
    y: 0,
    width: 9,
    height: 779
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M326.649 0.657472C324.123 0.650539 322.855 0.637448 322.855 0.637448C322.855 0.637448 321.588 0.624174 319.061 0.607415C319.165 92.7392 319.221 138.805 319.221 138.805L319.368 267.02L319.524 403.73L319.673 535.165L319.829 670.026C319.829 670.026 319.872 706.148 319.95 778.403C322.485 778.42 323.744 778.433 323.744 778.433C323.744 778.433 325.012 778.447 327.538 778.463C327.46 706.199 327.417 670.066 327.417 670.066L327.261 535.216L327.112 403.78L326.956 267.07L326.809 138.855C326.809 138.855 326.753 92.7892 326.649 0.657472Z",
    fill: "white"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask29_2925_19743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M323.205 335.426C323.205 335.426 321.938 335.439 319.411 335.374C319.431 352.462 319.45 369.556 319.461 382.372C321.987 382.34 323.252 382.424 323.252 382.424C323.24 369.607 323.225 352.513 323.205 335.426Z",
    fill: "#ADADAC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask30_2925_19743",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 319,
    y: 0,
    width: 9,
    height: 779
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M326.649 0.657472C324.123 0.650539 322.855 0.637448 322.855 0.637448C322.855 0.637448 321.588 0.624174 319.061 0.607415C319.165 92.7392 319.221 138.805 319.221 138.805L319.368 267.02L319.524 403.73L319.673 535.165L319.829 670.026C319.829 670.026 319.872 706.148 319.95 778.403C322.485 778.42 323.744 778.433 323.744 778.433C323.744 778.433 325.012 778.447 327.538 778.463C327.46 706.199 327.417 670.066 327.417 670.066L327.261 535.216L327.112 403.78L326.956 267.07L326.809 138.855C326.809 138.855 326.753 92.7892 326.649 0.657472Z",
    fill: "white"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask30_2925_19743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M323.259 382.419C323.259 382.419 321.996 382.432 319.468 382.367C319.474 388.775 319.478 394.113 319.481 397.854C322.011 397.822 323.275 397.906 323.275 397.906C323.303 394.168 323.272 388.826 323.259 382.419Z",
    fill: "#7F8082"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask31_2925_19743",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 319,
    y: 0,
    width: 9,
    height: 779
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M326.649 0.657472C324.123 0.650539 322.855 0.637448 322.855 0.637448C322.855 0.637448 321.588 0.624174 319.061 0.607415C319.165 92.7392 319.221 138.805 319.221 138.805L319.368 267.02L319.524 403.73L319.673 535.165L319.829 670.026C319.829 670.026 319.872 706.148 319.95 778.403C322.485 778.42 323.744 778.433 323.744 778.433C323.744 778.433 325.012 778.447 327.538 778.463C327.46 706.199 327.417 670.066 327.417 670.066L327.261 535.216L327.112 403.78L326.956 267.07L326.809 138.855C326.809 138.855 326.753 92.7892 326.649 0.657472Z",
    fill: "white"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask31_2925_19743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M323.275 397.909C323.275 397.909 322.012 397.923 319.481 397.857C319.452 401.595 319.478 403.73 319.478 403.73C322.004 403.698 323.272 403.782 323.272 403.782C323.272 403.782 323.247 401.646 323.275 397.909Z",
    fill: "#707374"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask32_2925_19743",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 319,
    y: 0,
    width: 9,
    height: 779
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M326.649 0.657472C324.123 0.650539 322.855 0.637448 322.855 0.637448C322.855 0.637448 321.588 0.624174 319.061 0.607415C319.165 92.7392 319.221 138.805 319.221 138.805L319.368 267.02L319.524 403.73L319.673 535.165L319.829 670.026C319.829 670.026 319.872 706.148 319.95 778.403C322.485 778.42 323.744 778.433 323.744 778.433C323.744 778.433 325.012 778.447 327.538 778.463C327.46 706.199 327.417 670.066 327.417 670.066L327.261 535.216L327.112 403.78L326.956 267.07L326.809 138.855C326.809 138.855 326.753 92.7892 326.649 0.657472Z",
    fill: "white"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask32_2925_19743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327.072 403.81C324.546 403.842 323.285 403.758 323.285 403.758C323.285 403.758 323.309 405.812 323.279 409.406C323.279 409.406 324.542 409.388 327.07 409.453C327.1 405.854 327.072 403.81 327.072 403.81Z",
    fill: "#6B6D6F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask33_2925_19743",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 319,
    y: 0,
    width: 9,
    height: 779
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M326.649 0.657472C324.123 0.650539 322.855 0.637448 322.855 0.637448C322.855 0.637448 321.588 0.624174 319.061 0.607415C319.165 92.7392 319.221 138.805 319.221 138.805L319.368 267.02L319.524 403.73L319.673 535.165L319.829 670.026C319.829 670.026 319.872 706.148 319.95 778.403C322.485 778.42 323.744 778.433 323.744 778.433C323.744 778.433 325.012 778.447 327.538 778.463C327.46 706.199 327.417 670.066 327.417 670.066L327.261 535.216L327.112 403.78L326.956 267.07L326.809 138.855C326.809 138.855 326.753 92.7892 326.649 0.657472Z",
    fill: "white"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask33_2925_19743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327.077 409.454C324.55 409.388 323.29 409.407 323.29 409.407C323.26 413.001 323.299 418.137 323.302 424.297C323.302 424.297 324.569 424.279 327.096 424.344C327.094 418.184 327.092 413.048 327.077 409.454Z",
    fill: "#707374"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask34_2925_19743",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 319,
    y: 0,
    width: 9,
    height: 779
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M326.649 0.657472C324.123 0.650539 322.855 0.637448 322.855 0.637448C322.855 0.637448 321.588 0.624174 319.061 0.607415C319.165 92.7392 319.221 138.805 319.221 138.805L319.368 267.02L319.524 403.73L319.673 535.165L319.829 670.026C319.829 670.026 319.872 706.148 319.95 778.403C322.485 778.42 323.744 778.433 323.744 778.433C323.744 778.433 325.012 778.447 327.538 778.463C327.46 706.199 327.417 670.066 327.417 670.066L327.261 535.216L327.112 403.78L326.956 267.07L326.809 138.855C326.809 138.855 326.753 92.7892 326.649 0.657472Z",
    fill: "white"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask34_2925_19743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327.096 424.341C324.57 424.373 323.306 424.294 323.306 424.294C323.319 436.612 323.336 453.042 323.355 469.471C323.355 469.471 324.618 469.453 327.146 469.518C327.126 453.095 327.117 436.664 327.096 424.341Z",
    fill: "#7F8082"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask35_2925_19743",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 319,
    y: 0,
    width: 9,
    height: 779
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M326.649 0.657472C324.123 0.650539 322.855 0.637448 322.855 0.637448C322.855 0.637448 321.588 0.624174 319.061 0.607415C319.165 92.7392 319.221 138.805 319.221 138.805L319.368 267.02L319.524 403.73L319.673 535.165L319.829 670.026C319.829 670.026 319.872 706.148 319.95 778.403C322.485 778.42 323.744 778.433 323.744 778.433C323.744 778.433 325.012 778.447 327.538 778.463C327.46 706.199 327.417 670.066 327.417 670.066L327.261 535.216L327.112 403.78L326.956 267.07L326.809 138.855C326.809 138.855 326.753 92.7892 326.649 0.657472Z",
    fill: "white"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask35_2925_19743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327.146 469.514C324.62 469.546 323.359 469.467 323.359 469.467C323.379 485.896 323.396 502.324 323.409 514.649C323.409 514.649 324.672 514.63 327.199 514.696C327.186 502.372 327.166 485.943 327.146 469.514Z",
    fill: "#ADADAC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask36_2925_19743",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 319,
    y: 0,
    width: 9,
    height: 779
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M326.649 0.657472C324.123 0.650539 322.855 0.637448 322.855 0.637448C322.855 0.637448 321.588 0.624174 319.061 0.607415C319.165 92.7392 319.221 138.805 319.221 138.805L319.368 267.02L319.524 403.73L319.673 535.165L319.829 670.026C319.829 670.026 319.872 706.148 319.95 778.403C322.485 778.42 323.744 778.433 323.744 778.433C323.744 778.433 325.012 778.447 327.538 778.463C327.46 706.199 327.417 670.066 327.417 670.066L327.261 535.216L327.112 403.78L326.956 267.07L326.809 138.855C326.809 138.855 326.753 92.7892 326.649 0.657472Z",
    fill: "white"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask36_2925_19743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327.201 514.701C324.675 514.733 323.41 514.654 323.41 514.654C323.413 520.814 323.418 525.947 323.426 529.539C323.426 529.539 324.689 529.521 327.22 529.587C327.25 525.992 327.204 520.861 327.201 514.701Z",
    fill: "#DCDBD8"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask37_2925_19743",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 319,
    y: 0,
    width: 9,
    height: 779
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M326.649 0.657472C324.123 0.650539 322.855 0.637448 322.855 0.637448C322.855 0.637448 321.588 0.624174 319.061 0.607415C319.165 92.7392 319.221 138.805 319.221 138.805L319.368 267.02L319.524 403.73L319.673 535.165L319.829 670.026C319.829 670.026 319.872 706.148 319.95 778.403C322.485 778.42 323.744 778.433 323.744 778.433C323.744 778.433 325.012 778.447 327.538 778.463C327.46 706.199 327.417 670.066 327.417 670.066L327.261 535.216L327.112 403.78L326.956 267.07L326.809 138.855C326.809 138.855 326.753 92.7892 326.649 0.657472Z",
    fill: "white"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask37_2925_19743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327.22 529.581C324.69 529.613 323.426 529.534 323.426 529.534C323.396 533.128 323.42 535.182 323.42 535.182C323.42 535.182 324.687 535.164 327.214 535.23C327.214 535.23 327.19 533.179 327.22 529.581Z",
    fill: "#ECEBE9"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask38_2925_19743",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 319,
    y: 0,
    width: 9,
    height: 779
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M326.649 0.657472C324.123 0.650539 322.855 0.637448 322.855 0.637448C322.855 0.637448 321.588 0.624174 319.061 0.607415C319.165 92.7392 319.221 138.805 319.221 138.805L319.368 267.02L319.524 403.73L319.673 535.165L319.829 670.026C319.829 670.026 319.872 706.148 319.95 778.403C322.485 778.42 323.744 778.433 323.744 778.433C323.744 778.433 325.012 778.447 327.538 778.463C327.46 706.199 327.417 670.066 327.417 670.066L327.261 535.216L327.112 403.78L326.956 267.07L326.809 138.855C326.809 138.855 326.753 92.7892 326.649 0.657472Z",
    fill: "white"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask38_2925_19743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M323.283 403.78C323.283 403.78 322.016 403.793 319.489 403.728C319.489 403.728 319.513 405.782 319.483 409.376C322.013 409.344 323.277 409.428 323.277 409.428C323.308 405.834 323.283 403.78 323.283 403.78Z",
    fill: "#6B6D6F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask39_2925_19743",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 319,
    y: 0,
    width: 9,
    height: 779
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M326.649 0.657472C324.123 0.650539 322.855 0.637448 322.855 0.637448C322.855 0.637448 321.588 0.624174 319.061 0.607415C319.165 92.7392 319.221 138.805 319.221 138.805L319.368 267.02L319.524 403.73L319.673 535.165L319.829 670.026C319.829 670.026 319.872 706.148 319.95 778.403C322.485 778.42 323.744 778.433 323.744 778.433C323.744 778.433 325.012 778.447 327.538 778.463C327.46 706.199 327.417 670.066 327.417 670.066L327.261 535.216L327.112 403.78L326.956 267.07L326.809 138.855C326.809 138.855 326.753 92.7892 326.649 0.657472Z",
    fill: "white"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask39_2925_19743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M323.289 409.423C323.289 409.423 322.025 409.441 319.494 409.375C319.464 412.97 319.503 418.102 319.506 424.266C322.036 424.234 323.3 424.313 323.3 424.313C323.298 418.153 323.289 413.016 323.289 409.423Z",
    fill: "#707374"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask40_2925_19743",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 319,
    y: 0,
    width: 9,
    height: 779
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M326.649 0.657472C324.123 0.650539 322.855 0.637448 322.855 0.637448C322.855 0.637448 321.588 0.624174 319.061 0.607415C319.165 92.7392 319.221 138.805 319.221 138.805L319.368 267.02L319.524 403.73L319.673 535.165L319.829 670.026C319.829 670.026 319.872 706.148 319.95 778.403C322.485 778.42 323.744 778.433 323.744 778.433C323.744 778.433 325.012 778.447 327.538 778.463C327.46 706.199 327.417 670.066 327.417 670.066L327.261 535.216L327.112 403.78L326.956 267.07L326.809 138.855C326.809 138.855 326.753 92.7892 326.649 0.657472Z",
    fill: "white"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask40_2925_19743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M323.304 424.323C323.304 424.323 322.041 424.337 319.509 424.271C319.522 436.591 319.539 453.02 319.559 469.449C322.089 469.417 323.353 469.496 323.353 469.496C323.334 453.067 323.317 436.642 323.304 424.323Z",
    fill: "#7F8082"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask41_2925_19743",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 319,
    y: 0,
    width: 9,
    height: 779
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M326.649 0.657472C324.123 0.650539 322.855 0.637448 322.855 0.637448C322.855 0.637448 321.588 0.624174 319.061 0.607415C319.165 92.7392 319.221 138.805 319.221 138.805L319.368 267.02L319.524 403.73L319.673 535.165L319.829 670.026C319.829 670.026 319.872 706.148 319.95 778.403C322.485 778.42 323.744 778.433 323.744 778.433C323.744 778.433 325.012 778.447 327.538 778.463C327.46 706.199 327.417 670.066 327.417 670.066L327.261 535.216L327.112 403.78L326.956 267.07L326.809 138.855C326.809 138.855 326.753 92.7892 326.649 0.657472Z",
    fill: "white"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask41_2925_19743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M323.357 469.491C323.357 469.491 322.094 469.509 319.563 469.443C319.583 485.872 319.6 502.301 319.613 514.621C322.139 514.589 323.407 514.668 323.407 514.668C323.394 502.344 323.377 485.92 323.357 469.491Z",
    fill: "#ADADAC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask42_2925_19743",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 319,
    y: 0,
    width: 9,
    height: 779
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M326.649 0.657472C324.123 0.650539 322.855 0.637448 322.855 0.637448C322.855 0.637448 321.588 0.624174 319.061 0.607415C319.165 92.7392 319.221 138.805 319.221 138.805L319.368 267.02L319.524 403.73L319.673 535.165L319.829 670.026C319.829 670.026 319.872 706.148 319.95 778.403C322.485 778.42 323.744 778.433 323.744 778.433C323.744 778.433 325.012 778.447 327.538 778.463C327.46 706.199 327.417 670.066 327.417 670.066L327.261 535.216L327.112 403.78L326.956 267.07L326.809 138.855C326.809 138.855 326.753 92.7892 326.649 0.657472Z",
    fill: "white"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask42_2925_19743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M323.414 514.678C323.414 514.678 322.147 514.696 319.62 514.63C319.622 520.789 319.628 525.927 319.635 529.521C322.165 529.488 323.43 529.568 323.43 529.568C323.46 525.975 323.417 520.837 323.414 514.678Z",
    fill: "#DCDBD8"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask43_2925_19743",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 319,
    y: 0,
    width: 9,
    height: 779
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M326.649 0.657472C324.123 0.650539 322.855 0.637448 322.855 0.637448C322.855 0.637448 321.588 0.624174 319.061 0.607415C319.165 92.7392 319.221 138.805 319.221 138.805L319.368 267.02L319.524 403.73L319.673 535.165L319.829 670.026C319.829 670.026 319.872 706.148 319.95 778.403C322.485 778.42 323.744 778.433 323.744 778.433C323.744 778.433 325.012 778.447 327.538 778.463C327.46 706.199 327.417 670.066 327.417 670.066L327.261 535.216L327.112 403.78L326.956 267.07L326.809 138.855C326.809 138.855 326.753 92.7892 326.649 0.657472Z",
    fill: "white"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask43_2925_19743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M323.43 529.559C323.43 529.559 322.167 529.577 319.635 529.511C319.605 533.106 319.63 535.16 319.63 535.16C322.16 535.128 323.424 535.207 323.424 535.207C323.424 535.207 323.4 533.153 323.43 529.559Z",
    fill: "#ECEBE9"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask44_2925_19743",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 319,
    y: 0,
    width: 9,
    height: 779
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M326.649 0.657472C324.123 0.650539 322.855 0.637448 322.855 0.637448C322.855 0.637448 321.588 0.624174 319.061 0.607415C319.165 92.7392 319.221 138.805 319.221 138.805L319.368 267.02L319.524 403.73L319.673 535.165L319.829 670.026C319.829 670.026 319.872 706.148 319.95 778.403C322.485 778.42 323.744 778.433 323.744 778.433C323.744 778.433 325.012 778.447 327.538 778.463C327.46 706.199 327.417 670.066 327.417 670.066L327.261 535.216L327.112 403.78L326.956 267.07L326.809 138.855C326.809 138.855 326.753 92.7892 326.649 0.657472Z",
    fill: "white"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask44_2925_19743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327.226 535.23C324.699 535.262 323.431 535.182 323.431 535.182C323.431 535.182 323.456 537.289 323.427 540.979C323.427 540.979 324.69 540.961 327.222 541.026C327.251 537.336 327.226 535.23 327.226 535.23Z",
    fill: "#F2F1EF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask45_2925_19743",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 319,
    y: 0,
    width: 9,
    height: 779
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M326.649 0.657472C324.123 0.650539 322.855 0.637448 322.855 0.637448C322.855 0.637448 321.588 0.624174 319.061 0.607415C319.165 92.7392 319.221 138.805 319.221 138.805L319.368 267.02L319.524 403.73L319.673 535.165L319.829 670.026C319.829 670.026 319.872 706.148 319.95 778.403C322.485 778.42 323.744 778.433 323.744 778.433C323.744 778.433 325.012 778.447 327.538 778.463C327.46 706.199 327.417 670.066 327.417 670.066L327.261 535.216L327.112 403.78L326.956 267.07L326.809 138.855C326.809 138.855 326.753 92.7892 326.649 0.657472Z",
    fill: "white"
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask45_2925_19743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327.232 541.029C324.702 541.061 323.438 540.982 323.438 540.982C323.409 544.666 323.443 549.937 323.455 556.254C323.455 556.254 324.722 556.236 327.249 556.301C327.244 549.979 327.241 544.717 327.232 541.029Z",
    fill: "#ECEBE9"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask46_2925_19743",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 319,
    y: 0,
    width: 9,
    height: 779
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M326.649 0.657472C324.123 0.650539 322.855 0.637448 322.855 0.637448C322.855 0.637448 321.588 0.624174 319.061 0.607415C319.165 92.7392 319.221 138.805 319.221 138.805L319.368 267.02L319.524 403.73L319.673 535.165L319.829 670.026C319.829 670.026 319.872 706.148 319.95 778.403C322.485 778.42 323.744 778.433 323.744 778.433C323.744 778.433 325.012 778.447 327.538 778.463C327.46 706.199 327.417 670.066 327.417 670.066L327.261 535.216L327.112 403.78L326.956 267.07L326.809 138.855C326.809 138.855 326.753 92.7892 326.649 0.657472Z",
    fill: "white"
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask46_2925_19743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327.251 556.304C324.725 556.336 323.457 556.257 323.457 556.257C323.474 568.901 323.489 585.756 323.507 602.614C323.507 602.614 324.774 602.601 327.301 602.666C327.283 585.807 327.268 568.948 327.251 556.304Z",
    fill: "#DCDBD8"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask47_2925_19743",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 319,
    y: 0,
    width: 9,
    height: 779
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M326.649 0.657472C324.123 0.650539 322.855 0.637448 322.855 0.637448C322.855 0.637448 321.588 0.624174 319.061 0.607415C319.165 92.7392 319.221 138.805 319.221 138.805L319.368 267.02L319.524 403.73L319.673 535.165L319.829 670.026C319.829 670.026 319.872 706.148 319.95 778.403C322.485 778.42 323.744 778.433 323.744 778.433C323.744 778.433 325.012 778.447 327.538 778.463C327.46 706.199 327.417 670.066 327.417 670.066L327.261 535.216L327.112 403.78L326.956 267.07L326.809 138.855C326.809 138.855 326.753 92.7892 326.649 0.657472Z",
    fill: "white"
  }))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask47_2925_19743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327.303 602.666C324.777 602.698 323.509 602.619 323.509 602.619C323.534 619.473 323.549 636.332 323.558 648.977C323.558 648.977 324.825 648.958 327.353 649.024C327.343 636.379 327.32 619.52 327.303 602.666Z",
    fill: "#ADADAC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask48_2925_19743",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 319,
    y: 0,
    width: 9,
    height: 779
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M326.649 0.657472C324.123 0.650539 322.855 0.637448 322.855 0.637448C322.855 0.637448 321.588 0.624174 319.061 0.607415C319.165 92.7392 319.221 138.805 319.221 138.805L319.368 267.02L319.524 403.73L319.673 535.165L319.829 670.026C319.829 670.026 319.872 706.148 319.95 778.403C322.485 778.42 323.744 778.433 323.744 778.433C323.744 778.433 325.012 778.447 327.538 778.463C327.46 706.199 327.417 670.066 327.417 670.066L327.261 535.216L327.112 403.78L326.956 267.07L326.809 138.855C326.809 138.855 326.753 92.7892 326.649 0.657472Z",
    fill: "white"
  }))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask48_2925_19743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327.36 649.019C324.834 649.051 323.566 648.967 323.566 648.967C323.57 655.285 323.577 660.556 323.586 664.24C323.586 664.24 324.852 664.226 327.381 664.292C327.409 660.603 327.372 655.341 327.36 649.019Z",
    fill: "#7F8082"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask49_2925_19743",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 319,
    y: 0,
    width: 9,
    height: 779
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M326.649 0.657472C324.123 0.650539 322.855 0.637448 322.855 0.637448C322.855 0.637448 321.588 0.624174 319.061 0.607415C319.165 92.7392 319.221 138.805 319.221 138.805L319.368 267.02L319.524 403.73L319.673 535.165L319.829 670.026C319.829 670.026 319.872 706.148 319.95 778.403C322.485 778.42 323.744 778.433 323.744 778.433C323.744 778.433 325.012 778.447 327.538 778.463C327.46 706.199 327.417 670.066 327.417 670.066L327.261 535.216L327.112 403.78L326.956 267.07L326.809 138.855C326.809 138.855 326.753 92.7892 326.649 0.657472Z",
    fill: "white"
  }))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask49_2925_19743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327.375 664.302C324.848 664.334 323.581 664.25 323.581 664.25C323.552 667.94 323.577 670.046 323.577 670.046C323.577 670.046 324.844 670.033 327.371 670.098C327.371 670.098 327.346 667.987 327.375 664.302Z",
    fill: "#707374"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask50_2925_19743",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 319,
    y: 0,
    width: 9,
    height: 779
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M326.649 0.657472C324.123 0.650539 322.855 0.637448 322.855 0.637448C322.855 0.637448 321.588 0.624174 319.061 0.607415C319.165 92.7392 319.221 138.805 319.221 138.805L319.368 267.02L319.524 403.73L319.673 535.165L319.829 670.026C319.829 670.026 319.872 706.148 319.95 778.403C322.485 778.42 323.744 778.433 323.744 778.433C323.744 778.433 325.012 778.447 327.538 778.463C327.46 706.199 327.417 670.066 327.417 670.066L327.261 535.216L327.112 403.78L326.956 267.07L326.809 138.855C326.809 138.855 326.753 92.7892 326.649 0.657472Z",
    fill: "white"
  }))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask50_2925_19743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M323.435 535.207C323.435 535.207 322.172 535.226 319.641 535.16C319.641 535.16 319.666 537.268 319.637 540.952C322.167 540.92 323.431 540.999 323.431 540.999C323.46 537.309 323.435 535.207 323.435 535.207Z",
    fill: "#F2F1EF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask51_2925_19743",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 319,
    y: 0,
    width: 9,
    height: 779
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M326.649 0.657472C324.123 0.650539 322.855 0.637448 322.855 0.637448C322.855 0.637448 321.588 0.624174 319.061 0.607415C319.165 92.7392 319.221 138.805 319.221 138.805L319.368 267.02L319.524 403.73L319.673 535.165L319.829 670.026C319.829 670.026 319.872 706.148 319.95 778.403C322.485 778.42 323.744 778.433 323.744 778.433C323.744 778.433 325.012 778.447 327.538 778.463C327.46 706.199 327.417 670.066 327.417 670.066L327.261 535.216L327.112 403.78L326.956 267.07L326.809 138.855C326.809 138.855 326.753 92.7892 326.649 0.657472Z",
    fill: "white"
  }))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask51_2925_19743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M323.442 541.005C323.442 541.005 322.179 541.024 319.648 540.958C319.619 544.648 319.653 549.913 319.665 556.236C322.191 556.203 323.455 556.283 323.455 556.283C323.451 549.965 323.451 544.689 323.442 541.005Z",
    fill: "#ECEBE9"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask52_2925_19743",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 319,
    y: 0,
    width: 9,
    height: 779
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M326.649 0.657472C324.123 0.650539 322.855 0.637448 322.855 0.637448C322.855 0.637448 321.588 0.624174 319.061 0.607415C319.165 92.7392 319.221 138.805 319.221 138.805L319.368 267.02L319.524 403.73L319.673 535.165L319.829 670.026C319.829 670.026 319.872 706.148 319.95 778.403C322.485 778.42 323.744 778.433 323.744 778.433C323.744 778.433 325.012 778.447 327.538 778.463C327.46 706.199 327.417 670.066 327.417 670.066L327.261 535.216L327.112 403.78L326.956 267.07L326.809 138.855C326.809 138.855 326.753 92.7892 326.649 0.657472Z",
    fill: "white"
  }))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask52_2925_19743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M323.457 556.281C323.457 556.281 322.194 556.299 319.667 556.233C319.676 568.877 319.699 585.733 319.716 602.586C322.246 602.554 323.511 602.638 323.511 602.638C323.493 585.78 323.474 568.925 323.457 556.281Z",
    fill: "#DCDBD8"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask53_2925_19743",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 319,
    y: 0,
    width: 9,
    height: 779
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M326.649 0.657472C324.123 0.650539 322.855 0.637448 322.855 0.637448C322.855 0.637448 321.588 0.624174 319.061 0.607415C319.165 92.7392 319.221 138.805 319.221 138.805L319.368 267.02L319.524 403.73L319.673 535.165L319.829 670.026C319.829 670.026 319.872 706.148 319.95 778.403C322.485 778.42 323.744 778.433 323.744 778.433C323.744 778.433 325.012 778.447 327.538 778.463C327.46 706.199 327.417 670.066 327.417 670.066L327.261 535.216L327.112 403.78L326.956 267.07L326.809 138.855C326.809 138.855 326.753 92.7892 326.649 0.657472Z",
    fill: "white"
  }))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask53_2925_19743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M323.512 602.641C323.512 602.641 322.249 602.654 319.718 602.589C319.743 619.448 319.758 636.302 319.768 648.946C322.298 648.914 323.562 648.998 323.562 648.998C323.553 636.354 323.53 619.495 323.512 602.641Z",
    fill: "#ADADAC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask54_2925_19743",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 319,
    y: 0,
    width: 9,
    height: 779
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M326.649 0.657472C324.123 0.650539 322.855 0.637448 322.855 0.637448C322.855 0.637448 321.588 0.624174 319.061 0.607415C319.165 92.7392 319.221 138.805 319.221 138.805L319.368 267.02L319.524 403.73L319.673 535.165L319.829 670.026C319.829 670.026 319.872 706.148 319.95 778.403C322.485 778.42 323.744 778.433 323.744 778.433C323.744 778.433 325.012 778.447 327.538 778.463C327.46 706.199 327.417 670.066 327.417 670.066L327.261 535.216L327.112 403.78L326.956 267.07L326.809 138.855C326.809 138.855 326.753 92.7892 326.649 0.657472Z",
    fill: "white"
  }))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask54_2925_19743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M323.564 648.996C323.564 648.996 322.301 649.009 319.77 648.944C319.774 655.266 319.781 660.533 319.79 664.221C322.317 664.189 323.577 664.273 323.577 664.273C323.606 660.589 323.576 655.313 323.564 648.996Z",
    fill: "#7F8082"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask55_2925_19743",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 319,
    y: 0,
    width: 9,
    height: 779
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M326.649 0.657472C324.123 0.650539 322.855 0.637448 322.855 0.637448C322.855 0.637448 321.588 0.624174 319.061 0.607415C319.165 92.7392 319.221 138.805 319.221 138.805L319.368 267.02L319.524 403.73L319.673 535.165L319.829 670.026C319.829 670.026 319.872 706.148 319.95 778.403C322.485 778.42 323.744 778.433 323.744 778.433C323.744 778.433 325.012 778.447 327.538 778.463C327.46 706.199 327.417 670.066 327.417 670.066L327.261 535.216L327.112 403.78L326.956 267.07L326.809 138.855C326.809 138.855 326.753 92.7892 326.649 0.657472Z",
    fill: "white"
  }))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask55_2925_19743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M323.581 664.271C323.581 664.271 322.318 664.284 319.79 664.218C319.761 667.908 319.786 670.015 319.786 670.015C322.316 669.983 323.581 670.067 323.581 670.067C323.581 670.067 323.552 667.961 323.581 664.271Z",
    fill: "#707374"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask56_2925_19743",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 319,
    y: 0,
    width: 9,
    height: 779
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M326.649 0.657472C324.123 0.650539 322.855 0.637448 322.855 0.637448C322.855 0.637448 321.588 0.624174 319.061 0.607415C319.165 92.7392 319.221 138.805 319.221 138.805L319.368 267.02L319.524 403.73L319.673 535.165L319.829 670.026C319.829 670.026 319.872 706.148 319.95 778.403C322.485 778.42 323.744 778.433 323.744 778.433C323.744 778.433 325.012 778.447 327.538 778.463C327.46 706.199 327.417 670.066 327.417 670.066L327.261 535.216L327.112 403.78L326.956 267.07L326.809 138.855C326.809 138.855 326.753 92.7892 326.649 0.657472Z",
    fill: "white"
  }))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask56_2925_19743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327.382 670.093C324.856 670.125 323.588 670.041 323.588 670.041C323.588 670.041 323.615 672.301 323.597 676.817C323.597 676.817 324.86 676.803 327.391 676.869C327.409 672.353 327.382 670.093 327.382 670.093Z",
    fill: "#6B6D6F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask57_2925_19743",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 319,
    y: 0,
    width: 9,
    height: 779
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M326.649 0.657472C324.123 0.650539 322.855 0.637448 322.855 0.637448C322.855 0.637448 321.588 0.624174 319.061 0.607415C319.165 92.7392 319.221 138.805 319.221 138.805L319.368 267.02L319.524 403.73L319.673 535.165L319.829 670.026C319.829 670.026 319.872 706.148 319.95 778.403C322.485 778.42 323.744 778.433 323.744 778.433C323.744 778.433 325.012 778.447 327.538 778.463C327.46 706.199 327.417 670.066 327.417 670.066L327.261 535.216L327.112 403.78L326.956 267.07L326.809 138.855C326.809 138.855 326.753 92.7892 326.649 0.657472Z",
    fill: "white"
  }))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask57_2925_19743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327.389 676.867C324.859 676.899 323.594 676.815 323.594 676.815C323.576 681.331 323.607 688.103 323.616 697.134C323.616 697.134 324.883 697.12 327.411 697.186C327.402 688.155 327.393 681.383 327.389 676.867Z",
    fill: "#737677"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask58_2925_19743",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 319,
    y: 0,
    width: 9,
    height: 779
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M326.649 0.657472C324.123 0.650539 322.855 0.637448 322.855 0.637448C322.855 0.637448 321.588 0.624174 319.061 0.607415C319.165 92.7392 319.221 138.805 319.221 138.805L319.368 267.02L319.524 403.73L319.673 535.165L319.829 670.026C319.829 670.026 319.872 706.148 319.95 778.403C322.485 778.42 323.744 778.433 323.744 778.433C323.744 778.433 325.012 778.447 327.538 778.463C327.46 706.199 327.417 670.066 327.417 670.066L327.261 535.216L327.112 403.78L326.956 267.07L326.809 138.855C326.809 138.855 326.753 92.7892 326.649 0.657472Z",
    fill: "white"
  }))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask58_2925_19743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327.412 697.188C324.886 697.221 323.618 697.136 323.618 697.136C323.627 706.173 323.64 717.461 323.653 731.007C323.653 731.007 324.92 730.994 327.448 731.059C327.434 717.508 327.421 706.22 327.412 697.188Z",
    fill: "#8C8D8D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask59_2925_19743",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 319,
    y: 0,
    width: 9,
    height: 779
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M326.649 0.657472C324.123 0.650539 322.855 0.637448 322.855 0.637448C322.855 0.637448 321.588 0.624174 319.061 0.607415C319.165 92.7392 319.221 138.805 319.221 138.805L319.368 267.02L319.524 403.73L319.673 535.165L319.829 670.026C319.829 670.026 319.872 706.148 319.95 778.403C322.485 778.42 323.744 778.433 323.744 778.433C323.744 778.433 325.012 778.447 327.538 778.463C327.46 706.199 327.417 670.066 327.417 670.066L327.261 535.216L327.112 403.78L326.956 267.07L326.809 138.855C326.809 138.855 326.753 92.7892 326.649 0.657472Z",
    fill: "white"
  }))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask59_2925_19743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327.451 731.064C324.924 730.999 323.657 731.012 323.657 731.012C323.678 744.565 323.695 760.368 323.713 778.431C323.713 778.431 324.976 778.417 327.507 778.483C327.49 760.42 327.472 744.612 327.451 731.064Z",
    fill: "#B4B5B3"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask60_2925_19743",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 319,
    y: 0,
    width: 9,
    height: 779
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M326.649 0.657472C324.123 0.650539 322.855 0.637448 322.855 0.637448C322.855 0.637448 321.588 0.624174 319.061 0.607415C319.165 92.7392 319.221 138.805 319.221 138.805L319.368 267.02L319.524 403.73L319.673 535.165L319.829 670.026C319.829 670.026 319.872 706.148 319.95 778.403C322.485 778.42 323.744 778.433 323.744 778.433C323.744 778.433 325.012 778.447 327.538 778.463C327.46 706.199 327.417 670.066 327.417 670.066L327.261 535.216L327.112 403.78L326.956 267.07L326.809 138.855C326.809 138.855 326.753 92.7892 326.649 0.657472Z",
    fill: "white"
  }))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask60_2925_19743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M323.587 670.069C323.587 670.069 322.323 670.083 319.792 670.017C319.792 670.017 319.819 672.272 319.801 676.789C322.332 676.854 323.595 676.841 323.595 676.841C323.613 672.325 323.587 670.069 323.587 670.069Z",
    fill: "#6B6D6F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask61_2925_19743",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 319,
    y: 0,
    width: 9,
    height: 779
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M326.649 0.657472C324.123 0.650539 322.855 0.637448 322.855 0.637448C322.855 0.637448 321.588 0.624174 319.061 0.607415C319.165 92.7392 319.221 138.805 319.221 138.805L319.368 267.02L319.524 403.73L319.673 535.165L319.829 670.026C319.829 670.026 319.872 706.148 319.95 778.403C322.485 778.42 323.744 778.433 323.744 778.433C323.744 778.433 325.012 778.447 327.538 778.463C327.46 706.199 327.417 670.066 327.417 670.066L327.261 535.216L327.112 403.78L326.956 267.07L326.809 138.855C326.809 138.855 326.753 92.7892 326.649 0.657472Z",
    fill: "white"
  }))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask61_2925_19743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M323.598 676.843C323.598 676.843 322.335 676.857 319.804 676.791C319.786 681.307 319.817 688.084 319.826 697.115C322.352 697.083 323.616 697.167 323.616 697.167C323.608 688.136 323.603 681.359 323.598 676.843Z",
    fill: "#737677"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask62_2925_19743",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 319,
    y: 0,
    width: 9,
    height: 779
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M326.649 0.657472C324.123 0.650539 322.855 0.637448 322.855 0.637448C322.855 0.637448 321.588 0.624174 319.061 0.607415C319.165 92.7392 319.221 138.805 319.221 138.805L319.368 267.02L319.524 403.73L319.673 535.165L319.829 670.026C319.829 670.026 319.872 706.148 319.95 778.403C322.485 778.42 323.744 778.433 323.744 778.433C323.744 778.433 325.012 778.447 327.538 778.463C327.46 706.199 327.417 670.066 327.417 670.066L327.261 535.216L327.112 403.78L326.956 267.07L326.809 138.855C326.809 138.855 326.753 92.7892 326.649 0.657472Z",
    fill: "white"
  }))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask62_2925_19743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M323.619 697.165C323.619 697.165 322.355 697.179 319.828 697.113C319.837 706.144 319.85 717.436 319.863 730.984C322.389 730.952 323.654 731.036 323.654 731.036C323.641 717.489 323.628 706.202 323.619 697.165Z",
    fill: "#8C8D8D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask63_2925_19743",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 319,
    y: 0,
    width: 9,
    height: 779
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M326.649 0.657472C324.123 0.650539 322.855 0.637448 322.855 0.637448C322.855 0.637448 321.588 0.624174 319.061 0.607415C319.165 92.7392 319.221 138.805 319.221 138.805L319.368 267.02L319.524 403.73L319.673 535.165L319.829 670.026C319.829 670.026 319.872 706.148 319.95 778.403C322.485 778.42 323.744 778.433 323.744 778.433C323.744 778.433 325.012 778.447 327.538 778.463C327.46 706.199 327.417 670.066 327.417 670.066L327.261 535.216L327.112 403.78L326.956 267.07L326.809 138.855C326.809 138.855 326.753 92.7892 326.649 0.657472Z",
    fill: "white"
  }))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask63_2925_19743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M323.659 731.033C323.659 731.033 322.396 731.047 319.869 730.981C319.882 744.529 319.899 760.336 319.917 778.4C322.447 778.367 323.711 778.452 323.711 778.452C323.694 760.388 323.68 744.586 323.659 731.033Z",
    fill: "#B4B5B3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2925_19743",
    x1: 3.69565,
    y1: 330.348,
    x2: 643.891,
    y2: 330.348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177678,
    stopColor: "#6B6D6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.342514,
    stopColor: "#F2F1EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.518287,
    stopColor: "#6B6D6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.687264,
    stopColor: "#F2F1EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.860649,
    stopColor: "#6B6D6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F1EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2925_19743",
    x1: 3.69565,
    y1: 330.348,
    x2: 643.891,
    y2: 330.348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177678,
    stopColor: "#6B6D6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.342514,
    stopColor: "#F2F1EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.518287,
    stopColor: "#6B6D6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.687264,
    stopColor: "#F2F1EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.860649,
    stopColor: "#6B6D6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F1EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2925_19743",
    x1: -2.83659,
    y1: 205.028,
    x2: 650.414,
    y2: 205.028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177678,
    stopColor: "#6B6D6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.342514,
    stopColor: "#F2F1EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.518287,
    stopColor: "#6B6D6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.687264,
    stopColor: "#F2F1EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.860649,
    stopColor: "#6B6D6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F1EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2925_19743",
    x1: 273.21,
    y1: 721.086,
    x2: 399.577,
    y2: 623.118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177678,
    stopColor: "#6B6D6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.342514,
    stopColor: "#F2F1EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.518287,
    stopColor: "#6B6D6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.687264,
    stopColor: "#F2F1EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.860649,
    stopColor: "#6B6D6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F1EF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardTopPattern);
export default __webpack_public_path__ + "static/media/cardTopPattern.7570e0c93b0070a4504b7a07c1b1712b.svg";
export { ForwardRef as ReactComponent };